import { Pagination, Table } from 'antd';
import Popconfirm from 'antd/lib/popconfirm';
import Switch from 'antd/lib/switch';
import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { APPLICATION_ID, authFeatureConstants, PAGE_QUERY_PARAM, StatusFilterType } from '../../../../shared/constants/commonConstants';
import { INVENTORY_SAVE_LABTEST } from '../../../../shared/constants/urlEndPoints';
import { LabTestPackage, SavelabTestPackage } from '../../../../shared/models/labtest.model';
import { Package } from '../../../../shared/models/packageDetail.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { base64UrlEncode, canActivate, error, extractSecondLevelBaseUrl, formatPrice, success } from '../../../../utils/utility';
import '../list/LabTestList.less';
import { useHistory } from 'react-router-dom';
import { Test } from '../../../../shared/models/healthcheck.model';
import { ReactComponent as ApprovedIcon  } from '../../../../assets/images/svg/i_approved.svg';
import { ReactComponent as PendingIcon  } from '../../../../assets/images/svg/i_pending.svg';
import { ReactComponent as RejectedIcon  } from '../../../../assets/images/svg/i_rejected.svg';

const LabTestList = ({ match: { path }, packageItems, totalRecords, currentPage, paginationChangeEvent }: any): ReactElement => {
  const tableData = [] as any;
  const [packages, setPackages] = useState(null as any);
  const history = useHistory();
  const isAuthorized = canActivate(authFeatureConstants.EDIT_LAB_TESTS);

  useEffect((): void => {
    setPackages(packageItems);
  }, [packageItems]);

  const onChangeSwitch = (value: any, record: any): void => {
    let Pdata = packages ? [...packages] : [];
    Pdata = Pdata?.filter((item: any): any => item.id === record.Key);
    if (Pdata) {
      Pdata[0].isActive = !record.Active;
      Pdata[0].isApproved = false;
      onSavePackage(Pdata);
    }
  };

  const setPackageList = (updatedpackage: any): void => {
    setPackages(updatedpackage);
  };

  const extractPackage = async (pack: Package): Promise<LabTestPackage> => {

    const test: Test = {
      investigationId: pack.investigations[0].id,
      isActive: pack.investigations[0].isActive,
      departmentId: pack.investigations[0].groupId,
    };
    const data: LabTestPackage = {
      id: pack.id,
      profileId: pack.profileId,
      price: pack.price,
      discountedPrice: pack.discountedPrice,
      packageName: pack.packageName,
      statusName: pack.statusName,
      isActive: pack.isActive,
      test: { ...test },
    };
    return data;
  };

  const onSavePackage = async (PData: any): Promise<void> => {

    const packageD = PData[0] as Package;
    const payload: SavelabTestPackage = {
      applicationId: APPLICATION_ID,
      labTests: [await extractPackage(packageD)],
    };
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_SAVE_LABTEST;
    const response: any = await SendRequest.instance.post(url, payload);
    if (response && response.isSuccess) {
      const pitems = packages ? [...packages] : [];
      pitems.forEach((item: any): any => {
        if (item.id === packageD.id) {
          item.isActive = packageD.isActive;
          item.statusName = StatusFilterType.isSubmit;
        }
      });
      setPackageList(pitems);
      success(`Test/scan ${packageD && packageD.isActive ? ' enabled ' : ' disabled '} successfully`);
    } else if (response && response.errorMessage) {
      error(response.errorMessage);
    } else {
      error('Unable to configure the package. Please try after some time.');
    }
    return;
  };

  const onLabTestClick = (groupId: number, packageId: number): void => {
    if (isAuthorized) {
      history.push(extractSecondLevelBaseUrl(path) + '/edit-labtest-packages/' + base64UrlEncode(groupId.toString()) + '/' +
        base64UrlEncode(packageId.toString()) + PAGE_QUERY_PARAM + currentPage);
    }
  };

  const columns = [
    {
      title: 'Active',
      dataIndex: 'Active',
      key: 'active',
      width: '100',
      render: (e: any, record: any): any => (
        <div>
          <Popconfirm
            disabled={!isAuthorized}
            title={`Do you want to  ${record?.Active ? 'stop ' : 'enable '} appointments ?`}
            onConfirm={(value: any): any => onChangeSwitch(value, record)}
            okText="Yes"
            cancelText="No"
          >
            <Switch size="small"
              disabled={!isAuthorized}
              checked={record?.Active}
            />
          </Popconfirm>
        </div>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'name',
      width: '200px',
      render: (e: any, record: any): any => (
        <div className={isAuthorized ? 'action-link' : ''}>
          <p onClick={(): any => onLabTestClick(record.GroupId, record.Key)} className={`bold mb-0 ${isAuthorized ? 'mouse-pointer' : 'mouse-not-allowed'}`}> {record.Name}</p>
          <p className={`fsize_sm mb-0 ${isAuthorized ? 'mouse-pointer' : 'mouse-not-allowed'}`}
            onClick={(): any => onLabTestClick(record.GroupId, 0)}>{record.GroupName}</p>
        </div>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'Description',
      key: 'description',
      render: (e: any, record: any): any => (
        <p className="mb-0 fsize_sm">{record.Description}</p>
      ),
    },
    {
      title: 'MRP',
      dataIndex: 'MRP',
      key: 'mrp',
      render: (e: any, record: any): any => (
        <p style={{ width: 100 }} >{formatPrice(record.MRP, false)} </p>
      ),
    },
    {
      title: 'Disc.Price',
      dataIndex: 'DiscountPrice',
      key: 'disc.price',

      render: (e: any, record: any): any => (
        <p style={{ width: 100 }} >{formatPrice(record.DiscountPrice, false)} </p>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'Status',
      key: 'status',
      render: (text: any, record: any): ReactNode => {
        switch (record.StatusName) {
          case StatusFilterType.isApproved:
            return <div className="status verified" style={{ width: 100 }}>
              <ApprovedIcon className="fill-approved v-align-sub" /> Verified
                </div>;
          case StatusFilterType.isSubmit:
            return <div className="status pending" style={{ width: 100 }}>
              <PendingIcon className="fill-pending v-align-sub" /> Pending
                </div>;
          case StatusFilterType.isRejected:
            return <div className="status rejected" style={{ width: 100 }}>
              <RejectedIcon className="fill-rejected v-align-sub" /> Rejected
                </div>;
          default:
            return <div className="status pending" style={{ width: 100 }}>
              <PendingIcon className="fill-approved v-align-sub" /> Pending
                </div>;
        }
      },
    },
  ];

  if (packageItems) {
    packageItems.map((item: any): any => (
      tableData.push({
        Key: item.id,
        Active: item.isActive,
        Name: item.investigations[0].name,
        Description: item.investigations[0].description,
        MRP: item.price,
        DiscountPrice: item.discountedPrice,
        Status: item.isApproved,
        GroupName: item.investigations[0].groupName,
        GroupId: item.investigations[0].groupId,
        StatusName: item.statusName,
      })
    ));
  }

  return (
    <div className="LabTest">
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
      />
      {(tableData && tableData.length > 0 && totalRecords) &&
          <Pagination
            defaultCurrent={currentPage}
            defaultPageSize={5}
            total={totalRecords} onChange={(page: number, pagesize: any): any => paginationChangeEvent(page, pagesize)}
            className="mt-md text-center" />
      }
    </div>
  );
};

export default LabTestList;
